<template>
  <div class="tabs_content">
    <section v-if="entities">
      <template>
        <div class="filter search_only">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search" />
          </div>
          <div class="field_right">
            <div class="remaining-space">
              <div class="progressbar">
                <div class="progressbar__actual" :style="{ 'width': this.usedPercentage + '%' }">
                  <div class="progressbar__show" :style="{ 'width': '100%' }" />
                </div>
              </div>
              <div class="actual-space">{{ usedCountFormattedString }}</div>
            </div>
          </div>
        </div>

        <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="subscribers-periodic-pvrs">
            <table class="vypis">
              <thead>
              <tr v-if="entities.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in tableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>
              <tbody>
              <PeriodicPvrRow
                  v-for="entity in entities"
                  :entity="entity"
                  :key="entity.id"
                  :isDeletable="isEditable"
                  :selectedEntities="selectedEntities"
                  @input="select"
                  @deletePeriodicPvr="onDeletePeriodicPvr" />
              <tr v-if="entities.length === 0">
                <td colspan="8" v-translate>Nebylo nalezeno žádné pravidelné nahrávání.</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-periodic-pvrs"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import PeriodicPvrRow from "./PeriodicPvrRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailPeriodicPvrs",
  components: { PeriodicPvrRow },
  mixins: [listActions],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
      maximumPeriodicPvrs: 0,
    };
  },
  created(SubscriberService, PeriodicPvrService) {
    this.subscriberService = SubscriberService
    this.periodicPvrService = PeriodicPvrService

    this.getEntities()
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberPeriodicPvrs(this.entity.id, params).then((data) => {
        this.entities = data['periodic_pvrs']
        this.maximumPeriodicPvrs = data['maximum_periodic_pvrs']
        this.totalCount = data['totalCount']
      })
    },
    onDeletePeriodicPvr(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deletePeriodicPvr');
      } else {
        this.periodicPvrService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities()
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeletePeriodicPvr(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberPeriodicPvrs(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['periodic_pvrs']);
      })
    },
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sName' },
        { id: 2, name: this.$gettext('Vytvořilo zařízení') },
        { id: 3, name: this.$gettext('Uživatelské profily') },
        { id: 4, name: this.$gettext('Počet dní nahrávání zpět za CatchUp') },
        { id: 5, name: this.$gettext('Minimální čas začátku nahrávání') },
        { id: 6, name: this.$gettext('Kanál nahrávání') },
        { id: 7, name: this.$gettext('Datum vytvoření'), column: 'sTimestampCreated' },
      ]
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'device_name': { name: this.$gettext('Vytvořilo zařízení') },
        'profiles': {
          name: this.$gettext('Uživatelské profily'), callback: (entity) => {
            return entity.profiles.map(i => i.name).join(', ')
          }
        },
        'days_back': { name: this.$gettext('Počet dní nahrávání zpět za CatchUp') },
        'minimal_timestamp': { name: this.$gettext('Minimální čas začátku nahrávání') },
        'channel_names': {
          name: this.$gettext('Kanál nahrávání'), callback: (entity) => {
            return entity.channel_names.join(', ')
          }
        },
        'timestamp_created': { name: this.$gettext('Datum vytvoření') }
      }
    },
    usedPercentage() {
      let result = (this.totalCount * 100) / this.maximumPeriodicPvrs;

      return result > 100 ? 100 : result;
    },
    usedCountFormattedString() {
      return this.$gettextInterpolate(this.$gettext("Využito %{used} z %{total}"), {
        used: this.totalCount,
        total: this.maximumPeriodicPvrs,
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/periodicPvrs/PeriodicPvrs.vue